"use client";
import {createContext} from "react";
import {FCWithHTMLAttributes} from "../../types/reactTypes";
import {TextContentNode, TextNodeType} from "./CmsTypes";
import TextContent from "./TextContent";
import {Block} from "@/shared/strapiTypes/common/Blocks";

type ClassNamesByType = {[key in TextNodeType]?: string};

interface TextContentContext {
	classNamesByType?: ClassNamesByType;
	variables?: Record<string, any>;
}

export const TextContentContext = createContext<TextContentContext>({});

interface TextSectionProps {
	contents: TextContentNode[] | Block[];
	classNamesByType?: ClassNamesByType;
	variables?: Record<string, any>;
}

/**
 * Renders a list of rich text nodes, which is the output of a single
 * "Rich text (Blocks)" Strapi field. See TextContent.tsx and CmsTypes.ts
 * for details on the types.
 */
const TextSection: FCWithHTMLAttributes<TextSectionProps> = ({
	contents,
	classNamesByType,
	variables,
	...props
}) => {
	if (!contents) {
		return null;
	}
	return (
		<TextContentContext.Provider value={{classNamesByType, variables}}>
			<div {...props}>
				{contents.map((node, i) => (
					<TextContent key={i} node={node} />
				))}
			</div>
		</TextContentContext.Provider>
	);
};

export default TextSection;
